export const SITE_ORIGIN = "https://auburnrvresort.com";

/** Absolute URL for canonical tags and other SEO links. */
export function absoluteUrl(path: string) {
  return new URL(path, SITE_ORIGIN).href;
}
